import { useState, useEffect } from 'react'
import Grow from '@material-ui/core/Grow'

import './legend.css'

function Legends(props) {
  const [geology, setGeology] = useState(false)
  const [population, setPopulation] = useState(false)

  useEffect(() => {
    if (props.layerData.find((obj) => obj.id === 'geology') !== undefined) {
      setGeology(props.layerData.find((obj) => obj.id === 'geology').visible)
    }
    if (props.layerData.find((obj) => obj.id === 'indigenous_presence') !== undefined) {
      setPopulation(props.layerData.find((obj) => obj.id === 'indigenous_presence').visible)
    }
  }, [props.layerData])

  const leyend = [
    { lbl: 'Sedimentary', color: '#d0c362' },
    { lbl: 'Extrusive', color: '#915845' },
    { lbl: 'Hybrid', color: '#498a9b' },
    { lbl: 'Metamorphic', color: '#aa579f' },
    { lbl: 'Intrusive', color: '#ff5252' },
    { lbl: 'Not Applicable', color: '#3d3d3d' },
  ]

  return (
    <div>
      <Grow in={geology} timeout={{ appear: 1000, enter: 1000, exit: 200 }}>
        <div className="rock-info">
          <p className="rock-info-title">Rock Types</p>
          {leyend.map((tag) => (
            <div className="rock-info-item">
              <div className="rock-info-color" style={{ background: `${tag.color}` }}></div>
              <p className="rock-info-labels">{tag.lbl}</p>
            </div>
          ))}
        </div>
      </Grow>
      <Grow in={population} timeout={{ appear: 1000, enter: 1000, exit: 200 }}>
        <div className="social-info">
          <p className="rock-info-title" style={{ marginTop: '0px' }}>
            % of Total Population
          </p>
          <div style={{ display: 'flex' }}>
            <label
              style={{ fontSize: '12px', fontWeight: 'bold', marginRight: '5px', width: '35px', textAlign: 'center' }}
            >
              0%
            </label>
            <div className="social-gradient" />
            <label
              style={{ fontSize: '12px', fontWeight: 'bold', marginLeft: '5px', width: '35px', textAlign: 'center' }}
            >
              100%
            </label>
          </div>
        </div>
      </Grow>
    </div>
  )
}

export default Legends
